export const truncateDecimals = (val: string | number, decimals = 2) => {
  const matchUpToDecimals = `-?\\d+(?:\\.\\d{0,${decimals}})?`;
  const matchedNums = val.toString().match(new RegExp(matchUpToDecimals));
  return matchedNums && matchedNums.length ? matchedNums[0] : val;
};
